module.exports = __webpack_public_path__ + "static/media/logo.f0a0bb16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 159
// module chunks = 0